import React        from "react"
import {NewsLayout} from "sections/News/"
import useNewsData  from "shared/Hooks/News/useNewsData"
import {Images}     from "src/sections/News/NewsLayout/Images";
import {List}       from "src/sections/News/NewsLayout/List";
import {NEWS_13}    from "types/News"

const Article = () => {
  const data = useNewsData(NEWS_13);

  return (
    <NewsLayout data={data}>
      <List data={data.lists.first}/>
      <Images data={data.images.first}/>
    </NewsLayout>
  )
}

export default Article;
